// A ranked row's match level as the server stored it beside percentage_match (Very Low 1 .. Very High 5).
export function matchLevelOf(entry) {
  return { label: entry?.match_level || "Very Low", rank: Number(entry?.match_level_rank) || 1 };
}

// The same ladder the server uses to stamp match_level from a 0-100 score: Very Low <20, Low <40, Medium <60, High <80, else Very High.
const MATCH_LEVELS = [
  [80, 5, "Very High"],
  [60, 4, "High"],
  [40, 3, "Medium"],
  [20, 2, "Low"],
  [0, 1, "Very Low"],
];
export function matchLevelFromScore(score) {
  const n = Number(score);
  if (!Number.isFinite(n)) return null;
  const hit = MATCH_LEVELS.find(([floor]) => n >= floor) || MATCH_LEVELS[MATCH_LEVELS.length - 1];
  return { label: hit[2], rank: hit[1] };
}
